//Returns a vertical list of right justified field labels and left justified field values
import React from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "components/Shared/ReadOnlyField";
import { zip } from "lodash";

export default class FieldGroup extends React.Component {

    constructor(props) {
        super(props);
        this.updateWidth = this.updateWidth.bind(this);
        this.state = {
            windowWidth: 0,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateWidth);
        this.updateWidth();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWidth);
    }

    updateWidth() {
        this.setState({
            windowWidth: window.innerWidth,
        });
    }

  render() {
    return (
      <div>
        {this.state.windowWidth < 600 ? (
          zip(this.props.labels, this.props.values).map(field => (
            <ReadOnlyField
              containerClassName="field-group-mobile"
              key={`${field[0]} ${field[1]}`}
              title={field[0]}
              fieldValue={field[1]}
              singeline
            />
          ))
        ) : (
          <div className="md-grid field-group">
            <div className="field-group-labels md-cell--6">
              {this.props.labels.map(label => (
                <div className="field-label" key={`${label} ${label} label`}>
                  {label}
                </div>
              ))}
            </div>
            <div className="field-group-values md-cell--6">
              {this.props.values.map(value => (
                <div className="field-value" key={`${value} ${value} value`}>
                  {value}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

FieldGroup.propTypes = {
  labels: PropTypes.array,
  values: PropTypes.array,
};
